var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 33.1875L23.6875 37.1562C26.5938 36.7812 29.8437 36.2187 29.8437 36.2187C32.0312 35.75 32.3125 35.125 32.3125 33.75V30.5625C32.3125 29.3125 31.3437 28.3125 30.125 28.2188L23.7187 27.8125L22.125 33.1875Z",
    fill: "url(#paint0_linear_536_3008)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 33.1875L16.3125 37.1562C13.4063 36.7812 10.1562 36.2187 10.1562 36.2187C7.96875 35.75 7.6875 35.125 7.6875 33.75V30.5625C7.6875 29.3125 8.65625 28.3125 9.875 28.2188L16.2812 27.8125L17.875 33.1875Z",
    fill: "url(#paint1_linear_536_3008)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4065 25.4062C14.4065 25.4062 12.1565 26.7187 10.9377 28.9062C10.7502 29.25 10.844 29.6875 11.1877 29.9375L13.594 31.5937L12.5315 33.25C12.3127 33.5937 12.4065 34.0625 12.719 34.3125C13.469 34.8438 14.8127 35.75 16.3127 36.4375L17.094 32.0937L16.3127 25.4062H14.4065Z",
    fill: "url(#paint2_linear_536_3008)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 28.875C27.875 26.7188 25.5937 25.375 25.5937 25.375H23.6875L22.9062 30.6563L23.6875 36.4063C25.1875 35.6875 26.5625 34.8125 27.2812 34.2812C27.625 34.0312 27.7187 33.5625 27.4687 33.2188L26.4062 31.5625L28.8125 29.9062C29.1562 29.6875 29.25 29.25 29.0625 28.875Z",
    fill: "url(#paint3_linear_536_3008)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.5938L16.3125 27.8125C16.3125 30.375 16.3125 34.3438 16.3125 37.125C17.7812 37.3125 19.1562 37.4688 20 37.4688C20.8437 37.4688 22.2188 37.3125 23.6875 37.125C23.6875 35.2188 23.6875 32.2812 23.6875 27.8125L20 27.5938Z",
    fill: "url(#paint4_linear_536_3008)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25V28.375C16.3125 30.4063 20 32.0625 20 32.0625C20 32.0625 23.6875 30.4063 23.6875 28.375V25.0312L16.3125 25Z",
    fill: "url(#paint5_linear_536_3008)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 6C16.4062 4.0625 17.9688 2.5 19.9063 2.5C21.8438 2.5 23.4063 4.0625 23.4063 6H16.4062Z",
    fill: "url(#paint6_linear_536_3008)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 7.28125C16.4062 2.65625 23.375 2.65625 23.375 7.28125H16.4062Z",
    fill: "url(#paint7_linear_536_3008)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 15.3125V12.875C10.6562 2.375 29.3437 2.375 29.3437 12.875V15.3125H10.6562Z",
    fill: "url(#paint8_linear_536_3008)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 5C7.59358 5 14.3123 11.5 14.9998 11.7813L19.9998 15.1562L24.9998 11.7813C25.6873 11.5 32.4061 5 19.9998 5Z",
    fill: "url(#paint9_linear_536_3008)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.2501C26.7501 27.2501 28.2501 21.8438 28.5626 19.2813C31.9376 19.1563 31.8751 14.0938 28.5626 14.0938C28.5626 13.3751 26.6563 10.9376 24.4688 10.9376C23.1563 10.9688 21.3126 11.8751 20.0001 11.8751C18.6876 11.8751 16.8438 10.9688 15.5313 10.9376C13.3438 10.9063 11.4376 13.3438 11.4376 14.0938C8.12505 14.0938 8.06255 19.1563 11.4376 19.2813C11.7501 21.8126 13.2501 27.2501 20.0001 27.2501Z",
    fill: "url(#paint10_radial_536_3008)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint11_linear_536_3008)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint12_linear_536_3008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_3008",
    x1: 27.2043,
    y1: 37.16,
    x2: 27.2043,
    y2: 27.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7015,
    stopColor: "#454849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_3008",
    x1: 12.7957,
    y1: 37.16,
    x2: 12.7957,
    y2: 27.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7015,
    stopColor: "#454849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_3008",
    x1: 13.9698,
    y1: 36.4197,
    x2: 13.9698,
    y2: 25.3932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#222424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#434647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_536_3008",
    x1: 26.0304,
    y1: 36.4198,
    x2: 26.0304,
    y2: 25.3932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#222424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#434647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505354"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_536_3008",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4697,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_3008",
    x1: 20,
    y1: 32.074,
    x2: 20,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1845,
    stopColor: "#FEB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#FCA695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#F78F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8337,
    stopColor: "#F27165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_536_3008",
    x1: 16.4097,
    y1: 4.2565,
    x2: 23.3927,
    y2: 4.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_536_3008",
    x1: 16.4097,
    y1: 5.54512,
    x2: 23.3927,
    y2: 5.54512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_536_3008",
    x1: 20,
    y1: 15.3113,
    x2: 20,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1667,
    stopColor: "#2A2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4338,
    stopColor: "#3C3E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7085,
    stopColor: "#47494A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4D4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_536_3008",
    x1: 12.5623,
    y1: 10.0765,
    x2: 27.4374,
    y2: 10.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292B2B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_536_3008",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.79334 11.837) scale(22.6997 22.6997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4432,
    stopColor: "#FFB6A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6343,
    stopColor: "#FFAF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7769,
    stopColor: "#FEA292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8946,
    stopColor: "#FD9182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9971,
    stopColor: "#FC7A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_536_3008",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_536_3008",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.cac873c3e898c66fae4cd7b869805a5a.svg";
export { ForwardRef as ReactComponent };